module.exports = __webpack_public_path__ + "img/7-fig1.c00aad66.png";